<script>
import VueChartJs from 'vue-chartjs';

  export default {
    name: 'hori-bar-chart',
    extends: VueChartJs.HorizontalBar,
    mixins: [VueChartJs.mixins.reactiveProp],
    props: ['chartData', 'options', 'disableLabels'],

    mounted () {
      this.addOptions();
      this.fillData();
    },
    methods: {
      addOptions () {
        this.options.plugins = this.options.plugins || {};

        if (!this.disableLabels) {
          this.options.plugins.datalabels = {
            display: true,
            align: 'end',
            anchor: 'end',
            offset: 2,
            formatter: function(value) {
              return Math.round(value) + '%';
            }
          };
        }
      },

      fillData () {
        this.renderChart(this.chartData, this.options);
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HoriBarChart.vue